import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import titleIcon from '../../asset/img/myinfo_password_title_icon.svg';

import Typography from '../../components/common/Typography';
import TextField from '../../components/common/TextField';
import { useTranslation } from 'react-i18next';
import CheckBox from '../../components/common/CheckBox';
import Button from '../../components/common/Button';
import { changePassword } from './myInfoSlice';
import { getAlertMessageFunction } from '../../common/Util';
import { handleChange, validatePassword } from './util';

const PasswordChange = ({ title }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('myInfo');
  const { myInfo } = useSelector(state => state.myInfo);

  const [form, setForm] = useState({
    password: '',
    newPassword: '',
    confirmPassword: '',
  });

  const [messages, setMessages] = useState({
    newPassword: { text: '', status: 'basic' },
    confirmPassword: { text: '', status: 'basic' },
  });

  const handleSubmit = async () => {
    console.log('form', form);
    const alertMessage = getAlertMessageFunction();

    try {
      const { newPassword, confirmPassword } = messages;

      if (newPassword.status === 'success' && confirmPassword.status === 'success') {
        let data = {
          htmComPass: form.password,
          newPass: form.newPassword,
          smsLoginFlag: '0',
        };
        const response = await dispatch(changePassword(data)).unwrap();

        const { result } = response;
        if (result) {
          //비밀번호가 변경되었습니다.
          alertMessage(t('alertMessage.passwordChangeSuccess'));
          setForm({
            password: '',
            newPassword: '',
            confirmPassword: '',
          });
          setMessages({
            newPassword: { text: '', status: 'basic' },
            confirmPassword: { text: '', status: 'basic' },
          });
        } else {
          //비밀번호 변경에 실패하였습니다.
          alertMessage(t('alertMessage.passwordChangeFail'));
        }
      }
    } catch (error) {
      alertMessage(t('alertMessage.passwordChangeFail'));
    }
  };

  const isDisabled = () => {
    return Object.values(messages).some(message => message.status !== 'success');
  };
  return (
    <div className="myInfoContentBox">
      {/* 제목 */}
      <div className="displayFlex" style={{ gap: '10px' }}>
        <div className="myInfoTitleIcon">
          <img src={titleIcon} alt="passwordChangeTitleIcon" />
        </div>
        <Typography>{title}</Typography>
      </div>

      {/* 비밀번호 입력 */}
      <div className="displayFlexColumn" style={{ gap: '10px' }}>
        <TextField
          placeholder={t('passwordInputPlaceholder')}
          size="small"
          onChange={e => handleChange(e, form, setForm, setMessages, t)}
          value={form.password}
          name="password"
          type="password"
        />
        <TextField
          placeholder={t('newPasswordInputPlaceholder')}
          size="small"
          message={messages.newPassword.text || t('newPasswordInputInfo1')}
          messageStatus={messages.newPassword.status}
          onChange={e => handleChange(e, form, setForm, setMessages, t)}
          value={form.newPassword}
          name="newPassword"
          type="password"
        />
        <TextField
          placeholder={t('confirmPasswordInputPlaceholder')}
          size="small"
          message={messages.confirmPassword.text || t('confirmPasswordInputInfo1')}
          messageStatus={messages.confirmPassword.status}
          onChange={e => handleChange(e, form, setForm, setMessages, t)}
          value={form.confirmPassword}
          name="confirmPassword"
          type="password"
        />
      </div>

      {/* 자동 로그인 체크박스 */}
      {/* <CheckBox label={t('checkBoxLabel')} size="regular" checked={true} /> */}

      {/* 비밀번호 변경 버튼 */}
      <Button
        size="large"
        value={t('passwordChangeButton')}
        color="secondary"
        onClick={handleSubmit}
        disabled={isDisabled()}
      />
    </div>
  );
};

export default PasswordChange;
